import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/JwtService";
import { number } from "yup";
/**
 * @description service to call HTTP request via Axios
 */
class contService {
    /**
     * @description initialize vue axios
     */
    static init(app) {
        contService.vueInstance = app;
        if (!contService.vueInstance.axios)
            contService.vueInstance.use(VueAxios, axios);
        contService.BaseUrl = import.meta.env.VITE_CONT_URL;
    }
    /**
     * @description set the default HTTP request headers
    */
    static setHeader() {
        contService.vueInstance.axios.defaults.headers.common["Authorization"] = "Bearer " + JwtService.getToken();
        contService.vueInstance.axios.defaults.headers.common["Accept"] =
            "application/json";
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static query(resource, params) {
        return contService.vueInstance.axios.get(`${contService.BaseUrl}/${resource}`, params);
    }
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    static get(resource, slug = "") {
        return contService.vueInstance.axios.get(`${contService.BaseUrl}/${resource}/${slug}`);
    }
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    static post(resource, params) {
        return contService.vueInstance.axios.post(`${contService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the PUT HTTP request
    * @param resource: string
    * @param params: AxiosRequestConfig
    * @returns Promise<AxiosResponse>
    */
    static put(resource, params) {
        return contService.vueInstance.axios.put(`${contService.BaseUrl}/${resource}`, params);
    }
    /**
    * @description Send the DELETE HTTP request
    * @param resource: string
    * @param slug: number
    * @returns Promise<AxiosResponse>
    */
    static delete(resource, slug = number) {
        return contService.vueInstance.axios.delete(`${contService.BaseUrl}/${resource}/${slug}`);
    }
}
export default contService;
//********** COMENTÁRIO GERADO EM: 10/11/2022 09:25:08 **********
////********** CÓDIGO GERADO PELO MAKECODEGENERETOR EM: 22/09/2022 04:56:41 **********
//import { App } from "vue";
//import axios from "axios";
//import VueAxios from "vue-axios";
//import JwtService from "@/core/services/JwtService";
//import { AxiosResponse, AxiosRequestConfig } from "axios";
//import { number } from "yup";
//
///**
// * @description service to call HTTP request via Axios
// */
//class contService {
//    /**
//     * @description property to share vue instance
//     */
//    public static vueInstance: App;
//    private static BaseUrl;
//
//    /**
//     * @description initialize vue axios
//     */
//    public static init(app: App<Element>){
//        contService.vueInstance = app;
//        contService.vueInstance.use(VueAxios, axios);
//        //contService.vueInstance.axios.defaults.baseURL = import.meta.env.VITE_cont_URL;
//        contService.BaseUrl = import.meta.env.VITE_CONT_URL;
//    }
//
//    /**
//     * @description set the default HTTP request headers
//    */
//    public static setHeader() : void {
//        contService.vueInstance.axios.defaults.headers.common[
//            "Authorization"
//        ] = "Bearer " + JwtService.getToken();
//		contService.vueInstance.axios.defaults.headers.common["Accept"] =
//            "application/json";
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static query(
//		resource: string,
//		params: AxiosRequestConfig
//
//    ) : Promise<AxiosResponse> {
//        return contService.vueInstance.axios.get(`${contService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//     * @description send the GET HTTP request
//     * @param resource: string
//     * @param slug: string
//     * @returns Promise<AxiosResponse>
//     */
//    public static get(
//        resource: string,
//        slug = "" as string
//    ): Promise<AxiosResponse> {
//        return contService.vueInstance.axios.get(`${contService.BaseUrl}/${resource}/${slug}`);
//    }
//
//    /**
//     * @description set the POST HTTP request
//     * @param resource: string
//     * @param params: AxiosRequestConfig
//     * @returns Promise<AxiosResponse>
//     */
//    public static post(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return contService.vueInstance.axios.post(`${contService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the PUT HTTP request
//    * @param resource: string
//    * @param params: AxiosRequestConfig
//    * @returns Promise<AxiosResponse>
//    */
//    public static put(
//        resource: string,
//        params: AxiosRequestConfig
//    ): Promise<AxiosResponse> {
//        return contService.vueInstance.axios.put(`${contService.BaseUrl}/${resource}`, params);
//    }
//
//    /**
//    * @description Send the DELETE HTTP request
//    * @param resource: string
//    * @param slug: number
//    * @returns Promise<AxiosResponse>
//    */
//    public static delete(
//        resource: string,
//        slug = number
//    ): Promise<AxiosResponse> {
//        return contService.vueInstance.axios.delete(`${contService.BaseUrl}/${resource}/${slug}`);
//    }
//
//
//}
//
//export default contService;
//
//
//********** FIM DO COMENTÁRIO **********
//# sourceMappingURL=contService.js.map